import React from "react";
import { Link } from "react-router-dom";

const InvalidCoupon = () => (
  <div className="error-message">
    <span>
      We're sorry, we don't recognize the coupon you've entered. Please try a
      different coupon or <Link to={"/store"}>proceed to checkout.</Link>
    </span>
  </div>
);

export default InvalidCoupon;
